/* eslint-disable import/prefer-default-export */

export const themes = {
    LIGHT: 'LIGHT',
    DARK: 'DARK',
};

export const types = {
    EMAIL: 'email',
    NUMBER: 'number',
    PASSWORD: 'password',
    TEXT: 'text',
    DATE: 'date',
    TEL: 'tel',
};
